import { useState, useContext } from 'react';
import axios from 'axios';
import { Stack, Box, Cluster } from '../../shared/layouts';
import Card from '../../shared/Card';
import Button from '../../shared/Button';
import Header from '../../shared/Header';
import TrashIcon from 'imagesUwKluis/svg/trash.svg';
import WhiteLabelContext from '../../../context/WhiteLabelContext';
import ConfirmModal from '../../shared/ConfirmModal';
import MessagebarContext from '../../../context/MessagebarContext';
import {useTranslation} from "react-i18next";

const AccountManagementSection = () => {
  const { t } = useTranslation();
  const [deleteAccountModal, setDeleteAccountModal] = useState(false);
  const { platformName } = useContext(WhiteLabelContext);
  const { setAlertMessage } = useContext(MessagebarContext);

  const deleteAccount = () => {
    axios
      .post('/user/settings/v2/dossier/delete')
      .catch(() => {
        setAlertMessage();
      })
      .then(() => {
        window.location.reload();
      });
  };

  return (
    <Card>
      <ConfirmModal
        isOpen={deleteAccountModal}
        title={t('Let op, je staat op het punt om je account te verwijderen!')}
        text={
          t('Weet je zeker dat je dit account wilt verwijderen? Dit kan niet ongedaan worden gemaakt.')
        }
        onCancel={() => setDeleteAccountModal(false)}
        onConfirm={deleteAccount}
      />
      <Stack space="m" width="100%">
        <Header
          title={t("Accountbeheer")}
          icon={<TrashIcon height="2rem" width="2rem" />}
          variant="section"
        />
        <Box>
          {t('Als je niet langer gebruik wilt maken van {{platformName}}, dan heb je hier de mogelijkheid om je account permanent te verwijderen. Na verwijderen kan je niet meer inloggen en zullen al je gegevens, berichten en documenten verdwijnen. Het verwijderen van je account kan niet ongedaan gemaakt worden.', {platformName})}
        </Box>
        <Cluster
          mt="xl"
          display="flex"
          maxWidth="100%"
          justifyContent="flex-end"
          hGap="m"
        >
          <Button variant="alert" onClick={() => setDeleteAccountModal(true)}>
            {t('Verwijder mijn account')}
          </Button>
        </Cluster>
      </Stack>
    </Card>
  );
};

export default AccountManagementSection;
